module.exports = __webpack_public_path__ + "img/jes.36fa9522.jpeg";